import React, { useState } from 'react';
import '../styles/modals.css';

const ChatSelectionModal = ({ 
  isOpen, 
  onClose, 
  onChatSelect, 
  fileInfo,
  currentChatName,
  hasExistingMessages 
}) => {
  // Debug logs removed

  const [selectedOption, setSelectedOption] = useState('current');

  const handleConfirm = () => {
    // onChatSelect called
    onChatSelect(selectedOption);
  };

  if (!isOpen) return null;

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Байт';
    const k = 1024;
    const sizes = ['Байт', 'КБ', 'МБ', 'ГБ'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    if (['mp3', 'wav', 'm4a', 'flac', 'ogg', 'aac'].includes(extension)) return '🎵';
    if (['mp4', 'avi', 'mkv', 'mov', 'webm'].includes(extension)) return '🎬';
    if (['pdf'].includes(extension)) return '📄';
    if (['doc', 'docx'].includes(extension)) return '📝';
    if (['txt'].includes(extension)) return '📄';
    return '📎';
  };

  return (
    <div 
      className="modal-overlay" 
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
        pointerEvents: 'auto'
      }}
      onClick={(e) => {
        // Закрываем только если кликнули именно по overlay, а не по содержимому
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div 
        className="modal-dialog chat-selection-modal" 
        style={{
          position: 'relative',
          zIndex: 100000,
          pointerEvents: 'auto'
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {/* Заголовок */}
        <div className="modal-header">
          <h4>Куда добавить файл?</h4>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        {/* Превью файла */}
        <div className="file-preview">
          <div className="file-icon">
            {getFileIcon(fileInfo?.name || '')}
          </div>
          <div className="file-details">
            <div className="file-name">{fileInfo?.name}</div>
            <div className="file-meta">
              {formatFileSize(fileInfo?.size || 0)}
            </div>
          </div>
        </div>
        
        {/* Опции выбора */}
        <div className="chat-options">
          <label className={`option-card ${selectedOption === 'current' ? 'selected' : ''}`}>
            <input 
              type="radio" 
              name="chatOption" 
              value="current"
              checked={selectedOption === 'current'}
              onChange={(e) => {
                setSelectedOption(e.target.value);
              }}
            />
            <div className="option-content">
              <h5>Продолжить в текущем чате</h5>
              <p>"{currentChatName}"</p>
              <small>
                {hasExistingMessages 
                  ? 'Файл будет добавлен к существующему контексту' 
                  : 'Файл будет добавлен в пустой чат'
                }
              </small>
            </div>
          </label>
          
          <label className={`option-card ${selectedOption === 'new' ? 'selected' : ''}`}>
            <input 
              type="radio" 
              name="chatOption" 
              value="new"
              checked={selectedOption === 'new'}
              onChange={(e) => {
                setSelectedOption(e.target.value);
              }}
            />
            <div className="option-content">
              <h5>Создать новый чат</h5>
              <p>Новый чат для этого файла</p>
              <small>Чистый контекст, посвященный только этому файлу</small>
            </div>
          </label>
        </div>
        
        {/* Кнопки действий */}
        <div className="modal-footer">
          <button 
            className="btn btn-secondary" 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
            }}
            style={{ pointerEvents: 'auto', zIndex: 9999 }}
          >
            Отмена
          </button>
          <button 
            className="btn btn-primary" 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChatSelect(selectedOption);
            }}
            style={{ pointerEvents: 'auto', zIndex: 9999 }}
          >
            Продолжить
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatSelectionModal; 